import { render, staticRenderFns } from "./td-clientTradeOpt.vue?vue&type=template&id=628880bc&"
import script from "./td-clientTradeOpt.vue?vue&type=script&lang=js&"
export * from "./td-clientTradeOpt.vue?vue&type=script&lang=js&"
import style0 from "./td-clientTradeOpt.vue?vue&type=style&index=0&id=628880bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports